module.exports = __webpack_public_path__ + "img/03d_color.eba4dfca.png";